import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-help",
  "use": "foquz-icon-vue-help-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-help\"><path d=\"M3.188 3.188L5.5 5.5m7.313-2.313L10.5 5.5m-7.313 7.313L5.5 10.5m7.313 2.313L10.5 10.5M15 8A7 7 0 111 8a7 7 0 0114 0zm-4 0a3 3 0 11-6 0 3 3 0 016 0z\" stroke=\"#679\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol